import { useLayoutEffect, useRef, useState } from 'react'

/** Measure the rendered text, not its character count, to enable an overflow-only tooltip. */
export const useLineClampedText = (text?: string | null, maxLines?: number) => {
  const ref = useRef<HTMLSpanElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  useLayoutEffect(() => {
    const element = ref.current
    if (!element || maxLines === undefined) {
      setIsTruncated(false)
      return
    }

    let active = true
    const measure = () => {
      if (active) {
        setIsTruncated(
          element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth
        )
      }
    }
    measure()
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure)
    observer?.observe(element)
    window.addEventListener('resize', measure)
    // Font loading may change wrapping without changing the clamped box's size.
    void document.fonts?.ready.then(measure)
    document.fonts?.addEventListener('loadingdone', measure)

    return () => {
      active = false
      observer?.disconnect()
      window.removeEventListener('resize', measure)
      document.fonts?.removeEventListener('loadingdone', measure)
    }
  }, [text, maxLines])

  return { ref, isTruncated }
}
